<script>
	import {push} from 'svelte-spa-router';
	import Explorer from './Explorer.svelte';
	import Reader from './Reader.svelte';
</script>

<button on:click={() => push('/cheatsheet/new')}>New</button>
<input placeholder="search">

<div class="home-container">
	<!-- Sidebar cheatsheet explorer -->
	<div id="sidebar-container">
		<Explorer />
	</div>

	<!-- Reader to display curSheet -->
	<div id="reader-container">
		<Reader />
	</div>
</div>

<style>
	.home-container {
		height: 100%;
	}

	#sidebar-container {
		margin-right: 0;
		width: 30%;
		float: left;
		height: 85%;
		overflow-y: scroll;
	}

	#reader-container {
		float:left;
		width: 70%;
	}
</style>